import React from 'react';
import ReactDOM from 'react-dom/client';
import {MsalProvider} from '@azure/msal-react';
import {PublicClientApplication} from '@azure/msal-browser';
import 'normalize.css/normalize.css';
import '@blueprintjs/core/lib/css/blueprint.css';
import '@blueprintjs/icons/lib/css/blueprint-icons.css';

export const msalInstance = (async () => {
    const configFile = await fetch("/env.json");
    window.env = await configFile.json();
    const {msalConfig} = await import('./authConfig');
    const instance = new PublicClientApplication(msalConfig);
    await instance.initialize();
    return instance;
})();

msalInstance.then(async instance => {
    const {Router} = await import('./routing');
    const root = ReactDOM.createRoot(
        document.getElementById('root') as HTMLElement
    );
    root.render(
        <React.StrictMode>
            <MsalProvider instance={instance}>
                <Router/>
            </MsalProvider>
        </React.StrictMode>
    );
});